module.exports = __webpack_public_path__ + "static/media/mundo-aba-logo.31e5f73f.png";